<div class="toast" [class]="`toast--${type()}`" aria-atomic="true" [attr.role]="role()" [attr.aria-live]="ariaLive()">
  <div class="toast__icon">
    @if (iconTemplate()) {
      <ng-container *ngTemplateOutlet="iconTemplate()" />
    } @else {
      <svg [ftrIcon]="icon()" [iconSize]="24"></svg>
    }
  </div>
  @if (title()) {
    <div class="toast__title">{{ title() }}</div>
  }
  <div class="toast__message">
    @if (messageTemplate()) {
      <ng-container *ngTemplateOutlet="messageTemplate()" />
    } @else {
      {{ message() }}
    }
  </div>
  @if (!hideClose()) {
    <div class="toast__close-container">
      <button
        class="toast__close"
        type="button"
        ftrIconButton
        icon="Close"
        iconColor="Grey40"
        (click)="closeToast.emit()"
      >
        Close
      </button>
    </div>
  }
</div>
